import { Component, ElementRef, EventEmitter, Output, OnInit, ViewChild } from '@angular/core';

import { ApiError, ConfigService, MessageService, ButtonLoader } from '../../../../../core';
import { ConfigEmpresa, createNomeCliente } from '../../../../configuracoes/app/empresa';
import { ConfigCliente } from '../../../../configuracoes/app/cliente';
import { ClienteInternet } from '../cliente-internet';
import { ClienteInternetHttpService } from '../services';
import { Cliente } from '../../cliente';
import { ClienteCrudHttpService, ClienteAuthGuardService } from '../../services';
import { ClienteInternetFormComponent } from '../form';

interface Config {
    canEdit: boolean;
}


@Component({
    selector: 'sgt-cliente-internet-form-modal',
    templateUrl: './cliente-internet-form-modal.component.html',
    styleUrls: ['./cliente-internet-form-modal.component.less']
})
export class ClienteInternetFormModalComponent implements OnInit {
    config: Config;
    configEmpresa: ConfigEmpresa;
    configCliente: ConfigCliente;

    elModal: any;
    @Output() afterUpdate = new EventEmitter<number>(); // Evento emitido após atualizar o cliente como "não atendido"
    @ViewChild('form') form: ClienteInternetFormComponent;

    entity: ClienteInternet;
    isLoading: boolean;

    // Cliente
    idCliente: number;
    cliente: Cliente;
    isLoadingCliente: boolean;

    constructor(private el: ElementRef,
                private configService: ConfigService,
                private messageService: MessageService,
                private clienteAuthGuardService: ClienteAuthGuardService,
                private clienteCrudHttpService: ClienteCrudHttpService,
                private clienteInternetHttpService: ClienteInternetHttpService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.configCliente = this.configService.getCliente();

        this.create();
    }

    /** Seta as configurações do form */
    private setConfig() {
        this.config = {
            canEdit: this.clienteAuthGuardService.canEditFichaCadastral(true, this.cliente)
        };
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                // jQuery(this.elModal).find('#motivoClienteNaoAtendido').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    private clear() {
        // Cliente
        this.idCliente = null;
        this.cliente = null;
    }

    /** Carrega o cliente */
    private findCliente(idCliente: number) {
        this.isLoadingCliente = true;
        this.clienteCrudHttpService.find(idCliente)
            .subscribe(
                entity => {
                    this.cliente = entity;
                    this.isLoadingCliente = false;
                },
                () => this.isLoadingCliente = false
            );
    }

    /** Carrega os dados de internet do cliente */
    private load(idCliente: number) {
        this.isLoading = true;
        this.clienteInternetHttpService.load(idCliente)
            .subscribe(
                entity => {
                    this.entity = entity;
                    this.isLoading = false;
                    this.setConfig();
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar os dados de internet do cliente', error);
                    this.isLoading = false;
                }
            );
    }

    open(idCliente: number) {
        this.clear();
        // Cliente
        this.idCliente = idCliente;
        this.findCliente(idCliente);

        this.load(idCliente);

        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Obtem o nome do cliente para o template */
    getNomeCliente(): string {
        if (!this.configEmpresa || !this.cliente || !this.cliente.pessoa) {
            return '';
        }
        return createNomeCliente(this.configEmpresa.identificacaoCliente, this.cliente.pessoa.nome, this.cliente.pessoa.nomeFantasia);
    }

    /** Antes de realizar a atualização das informações de internet do cliente */
    private beforeUpdate() {
        if (this.form) {
            this.form.beforeSave();
        }
    }

    /** Atualiza as informações de internet do cliente */
    update() {
        if (this.form.isValid()) {
            const btnUpdateClienteInternet = new ButtonLoader('#btnUpdateClienteInternet')
            btnUpdateClienteInternet.loading('Atualizando');

            this.beforeUpdate();
            this.clienteInternetHttpService.update(this.entity)
                .subscribe(
                    response => {
                        this.messageService.success('', response);
                        btnUpdateClienteInternet.reset();
                        this.close();
                        this.afterUpdate.emit(this.idCliente);
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao atualizar os dados de internet do cliente', error);
                        btnUpdateClienteInternet.reset();
                    }
                );
        } else {
            this.messageService.info('Para salvar é preciso informar corretamente todos os campos destacados em vermelho', 'Informação');
        }
    }
}
